import { css } from "@emotion/css";

export function TitleBar(props: { children: React.ReactNode }) {
  return (
    <div
      className={css({
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      })}
    >
      {props.children}
    </div>
  );
}
